import { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export interface VerticalTabsUniDriver extends BaseUniDriver {
  getActiveTabId: () => Promise<string | number>;
}

export const verticalTabsDriverFactory = (
  base: UniDriver,
): VerticalTabsUniDriver => {
  return {
    ...baseUniDriverFactory(base),
    getActiveTabId: async () => {
      const activeTabId = await base.attr('data-active-tab-id');
      const parsedId = parseInt(activeTabId!, 10);
      return isNaN(parsedId) ? activeTabId! : parsedId;
    },
  };
};
